'use client';

import { BackChevron } from '../../../../BackChevron/BackChevron';
import { GraphicContainer } from '../../../../GraphicContainer/GraphicContainer';

type CRMHeaderProps = {
  image: {
    link: string;
    altText: string;
  };
};

function CRMHeader({ image }: CRMHeaderProps): React.JSX.Element {
  return (
    <GraphicContainer
      image={{
        src: image.link,
        alt: image.altText,
      }}
      imageClassName="rounded-b-lg object-cover object-top"
      className="bg-background pb-0 w-full h-[163px] md:h-[176px]"
      data-testid="crm-header"
    >
      <BackChevron className="absolute top-5 left-0 size-8" />
    </GraphicContainer>
  );
}

export { CRMHeader, type CRMHeaderProps };
